<template>
    <b-row>
        <b-col cols="12">
            <div
                class="d-sm-flex justify-content-between align-items-center mb-4"
            >
                <feather
                    type="arrow-left-circle"
                    v-b-popover.hover.top="'Presione esc'"
                    role="button"
                    class="text-secondary"
                    size="2rem"
                    @click="back"
                ></feather>
                <div class="d-flex flex-row">
                    <b-button
                        variant="secondary"
                        :disabled="isLoading"
                        v-b-popover.hover.top="'Presione esc'"
                        size="md"
                        class="mr-4"
                        @click="back"
                    >
                        Cancelar
                    </b-button>

                    <b-button
                        variant="primary"
                        :disabled="isLoading || read_only"
                        size="md"
                        class="d-flex align-items-center"
                        v-b-popover.hover.top="
                            'Presione ctrl+shift+s o cmd+shift+s'
                        "
                        @click="save"
                    >
                        <feather
                            type="save"
                            size="1rem"
                            class="mr-2 text-blue-active"
                        />
                        <span
                            v-if="isLoading"
                            class="d-sm-flex align-items-center justify-content-center"
                        >
                            <b-spinner small></b-spinner>
                            <span class="ml-2">Guardando...</span>
                        </span>
                        <span v-else>Guardar</span>
                    </b-button>
                </div>
            </div>
        </b-col>
        <b-col
            cols="12"
            lg="12"
            class="d-flex align-items-stretch"
            style="min-height: 70vh"
        >
            <b-card class="mb-4 w-100">
                <div>
                    <b-form class="p-5">
                        <div class="d-flex">
                            <div>
                                <h3 class="mb-2">Datos del vendedor</h3>
                                <div class="text-gray mb-5">
                                    Por favor registre los datos del vendedor
                                    para continuar
                                </div>
                            </div>
                        </div>
                        <b-row v-hotkey="keymap">
                            <b-col cols="12" md="3" lg="3" xl="3">
                                <b-form-group>
                                    <label for="codigo">Código</label>
                                    <b-form-input
                                        id="codigo"
                                        type="text"
                                        placeholder="Ej: 001"
                                        v-model="$v.vendedor.codigo.$model"
                                        :state="validateState('codigo')"
                                        :disabled="read_only"
                                    >
                                    </b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="!$v.vendedor.codigo.$anyError"
                                    >
                                        ({{ $v.vendedor.codigo.$model.length }}
                                        /
                                        {{
                                            $v.vendedor.codigo.$params.maxLength
                                                .max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="!$v.vendedor.codigo.maxLength"
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.vendedor.codigo.$params.maxLength
                                                .max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.vendedor.codigo.required"
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="9" lg="9" xl="9">
                                <b-form-group>
                                    <label for="descripcion">Descripción</label>
                                    <b-form-input
                                        id="descripcion"
                                        type="text"
                                        placeholder="Ej: Descripción del vendedor"
                                        v-model="$v.vendedor.descripcion.$model"
                                        :state="validateState('descripcion')"
                                        :disabled="read_only"
                                    >
                                    </b-form-input>
                                    <div
                                        class="length-field mt-1"
                                        v-if="
                                            !$v.vendedor.descripcion.$anyError
                                        "
                                    >
                                        ({{
                                            $v.vendedor.descripcion.$model
                                                .length
                                        }}
                                        /
                                        {{
                                            $v.vendedor.descripcion.$params
                                                .maxLength.max
                                        }})
                                    </div>
                                    <b-form-invalid-feedback
                                        v-if="
                                            !$v.vendedor.descripcion.maxLength
                                        "
                                    >
                                        Este campo debe tener máximo
                                        {{
                                            $v.vendedor.descripcion.$params
                                                .maxLength.max
                                        }}
                                        caracteres
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        v-if="!$v.vendedor.descripcion.required"
                                    >
                                        Campo requerido
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-md-4">
                            <b-col cols="12" md="4" lg="4" xl="4">
                                <label for="descripcion"
                                    >Comisión contado</label
                                >
                                <currencyInput
                                    v-model="
                                        $v.vendedor.comision_contado.$model
                                    "
                                    :state="validateState('comision_contado')"
                                    :disabled="read_only"
                                />
                                <div
                                    class="length-field mt-1"
                                    v-if="
                                        !$v.vendedor.comision_contado.$anyError
                                    "
                                >
                                    ({{
                                        $v.vendedor.comision_contado.$model.toString()
                                            .length
                                    }}
                                    /
                                    {{
                                        $v.vendedor.comision_contado.$params
                                            .maxLength.max
                                    }})
                                </div>
                                <div
                                    class="invalid-field mt-1"
                                    v-if="$v.vendedor.comision_contado.$error"
                                >
                                    Este campo debe tener máximo
                                    {{
                                        $v.vendedor.comision_contado.$params
                                            .maxLength.max
                                    }}
                                    caracteres
                                </div>
                                <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                            </b-col>
                            <b-col cols="12" md="4" lg="4" xl="4">
                                <label for="descripcion">Comisión 30</label>
                                <currencyInput
                                    v-model="$v.vendedor.comision_30.$model"
                                    :state="validateState('comision_30')"
                                    :disabled="read_only"
                                />
                                <div
                                    class="length-field mt-1"
                                    v-if="!$v.vendedor.comision_30.$anyError"
                                >
                                    ({{
                                        $v.vendedor.comision_30.$model.toString()
                                            .length
                                    }}
                                    /
                                    {{
                                        $v.vendedor.comision_30.$params
                                            .maxLength.max
                                    }})
                                </div>
                                <div
                                    class="invalid-field mt-1"
                                    v-if="$v.vendedor.comision_30.$error"
                                >
                                    Este campo debe tener máximo
                                    {{
                                        $v.vendedor.comision_30.$params
                                            .maxLength.max
                                    }}
                                    caracteres
                                </div>
                                <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                            </b-col>
                            <b-col cols="12" md="4" lg="4" xl="4">
                                <label for="descripcion">Comisión 60</label>
                                <currencyInput
                                    v-model="$v.vendedor.comision_60.$model"
                                    :state="validateState('comision_60')"
                                    :disabled="read_only"
                                />
                                <div
                                    class="length-field mt-1"
                                    v-if="!$v.vendedor.comision_60.$anyError"
                                >
                                    ({{
                                        $v.vendedor.comision_60.$model.toString()
                                            .length
                                    }}
                                    /
                                    {{
                                        $v.vendedor.comision_60.$params
                                            .maxLength.max
                                    }})
                                </div>
                                <div
                                    class="invalid-field mt-1"
                                    v-if="$v.vendedor.comision_60.$error"
                                >
                                    Este campo debe tener máximo
                                    {{
                                        $v.vendedor.comision_60.$params
                                            .maxLength.max
                                    }}
                                    caracteres
                                </div>
                                <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                            </b-col>
                        </b-row>
                        <b-row class="mt-md-5">
                            <b-col cols="12" md="6" lg="6" xl="6">
                                <label for="descripcion">Comisión 90</label>
                                <currencyInput
                                    v-model="$v.vendedor.comision_90.$model"
                                    :state="validateState('comision_90')"
                                    :disabled="read_only"
                                />
                                <div
                                    class="length-field mt-1"
                                    v-if="!$v.vendedor.comision_90.$anyError"
                                >
                                    ({{
                                        $v.vendedor.comision_90.$model.toString()
                                            .length
                                    }}
                                    /
                                    {{
                                        $v.vendedor.comision_90.$params
                                            .maxLength.max
                                    }})
                                </div>
                                <div
                                    class="invalid-field mt-1"
                                    v-if="$v.vendedor.comision_90.$error"
                                >
                                    Este campo debe tener máximo
                                    {{
                                        $v.vendedor.comision_90.$params
                                            .maxLength.max
                                    }}
                                    caracteres
                                </div>
                                <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                            </b-col>
                            <b-col cols="12" md="6" lg="6" xl="6">
                                <label for="descripcion">Comisión 120</label>
                                <currencyInput
                                    v-model="$v.vendedor.comision_120.$model"
                                    :state="validateState('comision_120')"
                                    :disabled="read_only"
                                />
                                <div
                                    class="length-field mt-1"
                                    v-if="!$v.vendedor.comision_120.$anyError"
                                >
                                    ({{
                                        $v.vendedor.comision_120.$model.toString()
                                            .length
                                    }}
                                    /
                                    {{
                                        $v.vendedor.comision_120.$params
                                            .maxLength.max
                                    }})
                                </div>
                                <div
                                    class="invalid-field mt-1"
                                    v-if="$v.vendedor.comision_120.$error"
                                >
                                    Este campo debe tener máximo
                                    {{
                                        $v.vendedor.comision_120.$params
                                            .maxLength.max
                                    }}
                                    caracteres
                                </div>
                                <!-- @focus-c="registerIndex = i"
                  @input="registerIndex = i" -->
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </b-card>
        </b-col>
        <b-col cols="12">
            <div class="d-sm-flex justify-content-end align-items-center mb-4">
                <div class="d-flex flex-row">
                    <b-button
                        variant="secondary"
                        :disabled="isLoading"
                        v-b-popover.hover.top="'Presione esc'"
                        size="md"
                        class="mr-4"
                        @click="back"
                    >
                        Cancelar
                    </b-button>

                    <b-button
                        variant="primary"
                        :disabled="isLoading || read_only"
                        size="md"
                        class="d-flex align-items-center"
                        v-b-popover.hover.top="
                            'Presione ctrl+shift+s o cmd+shift+s'
                        "
                        @click="save"
                    >
                        <feather
                            type="save"
                            size="1rem"
                            class="mr-2 text-blue-active"
                        />
                        <span
                            v-if="isLoading"
                            class="d-sm-flex align-items-center justify-content-center"
                        >
                            <b-spinner small></b-spinner>
                            <span class="ml-2">Guardando...</span>
                        </span>
                        <span v-else>Guardar</span>
                    </b-button>
                </div>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import services from '@/boot/axios'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
// import jautocomplete from '@/components/shared/autocomplete/jautocomplete'
import currencyInput from '@/components/shared/currency-input/currency-input'
import {
    addListenerCommands,
    removeListenerCommands,
    compareObjects,
    goToNextField
} from '@/utils/others'
// import { filterTerceros } from '@/utils/filters'

const { API } = services

const defaultVendedor = () =>
    JSON.parse(
        JSON.stringify({
            codigo: '',
            descripcion: '',
            // tercero_id: null,
            comision_contado: 0,
            comision_30: 0,
            comision_60: 0,
            comision_90: 0,
            comision_120: 0,
            empresa_id: null
        })
    )

export default {
    name: 'CrearVendedor',
    mixins: [validationMixin],
    components: { currencyInput },
    data: () => ({
        // terceros: [],
        // tercerosCopy: [],
        read_only: false,
        vendedorCopy: defaultVendedor(),
        vendedor: defaultVendedor(),
        isLoading: false,
        isSaved: true
    }),
    watch: {
        vendedor: {
            handler(newValue) {
                this.isSaved = compareObjects(this.vendedorCopy, newValue)
            },
            deep: true
        }
    },
    mounted() {
        this.goToNextField('codigo')
        addListenerCommands(this)
        // this.getTerceros()
        this.getParams()
    },
    beforeDestroy() {
        removeListenerCommands(this)
    },
    beforeRouteLeave(to, from, next) {
        if (this.isSaved) {
            next()
        } else {
            this.$bvModal
                .msgBoxConfirm(
                    `
        Este formulario contiene información que no ha sido guardada,
        si continua con esta acción no se guardarán los cambios, desea continuar con esta acción?`,
                    {
                        title: 'Advertencia!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Continuar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2 d-flex justify-content-between',
                        hideHeaderClose: false,
                        centered: true,
                        headerBgVariant: 'danger',
                        headerClass: 'modal-header'
                    }
                )
                .then((value) => {
                    if (value) {
                        next()
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    validations: {
        vendedor: {
            codigo: {
                required,
                maxLength: maxLength(25)
            },
            descripcion: {
                required,
                maxLength: maxLength(150)
            },
            // tercero_id: {
            //     required
            // },
            comision_contado: {
                maxLength: maxLength(20)
            },
            comision_30: {
                maxLength: maxLength(20)
            },
            comision_60: {
                maxLength: maxLength(20)
            },
            comision_90: {
                maxLength: maxLength(20)
            },
            comision_120: {
                maxLength: maxLength(20)
            }
        }
    },
    methods: {
        goToNextField,
        showLog(data) {
            console.log(data)
        },
        // textFieldTercero(tercero) {
        //     return tercero.tipo_documento_id === '31'
        //         ? tercero.razon_social
        //         : `${tercero.nombre1} ${tercero.apellido1}`
        // },
        // filterTerceros,
        getParams() {
            const { vendedor_id } = this.$route.params
            if (vendedor_id) {
                this.getVendedorById(vendedor_id)
            }

            this.read_only = this.$route.meta.read_only
        },
        getVendedorById(id) {
            // console.log('acá 2');
            API.POST({
                url: 'administracion/vendedor/query',
                data: {
                    p_datajson: {
                        id
                    },
                    p_opc: 'FIND_BY_ID',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    const {
                        data: {
                            dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    if (status === 'ok') {
                        this.vendedorCopy = { ...dato }
                        this.vendedor = { ...dato }
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        // getTerceros() {
        //     if (this.getUltimaEmpresa) {
        //         API.POST({
        //             url: 'general/tercero/query',
        //             data: {
        //                 p_datajson: {
        //                     empresa_id: this.getUltimaEmpresa.id
        //                 },
        //                 p_opc: 'GET_ALL',
        //                 p_auditoriajson: this.auditoriajson
        //             }
        //         })
        //             .then((response) => {
        //                 const {
        //                     data: {
        //                         dato,
        //                         status: { status, mensaje, mensaje_exception }
        //                     }
        //                 } = response
        //                 if (status === 'ok') {
        //                     this.terceros = dato
        //                     this.tercerosCopy = dato
        //                 } else {
        //                     this.$bvModal
        //                         .msgBoxOk(
        //                             mensaje ||
        //                                 mensaje_exception ||
        //                                 'Ha ocurrido un error!',
        //                             {
        //                                 title: 'Error!',
        //                                 size: 'sm',
        //                                 buttonSize: 'sm',
        //                                 okVariant: 'error',
        //                                 okTitle: 'Aceptar',
        //                                 cancelTitle: 'Cancelar',
        //                                 footerClass: 'p-2',
        //                                 hideHeaderClose: false,
        //                                 centered: true,
        //                                 headerBgVariant: 'error',
        //                                 headerClass: 'modal-header'
        //                             }
        //                         )
        //                         .then(() => {
        //                             // console.log(value);
        //                         })
        //                         .catch((err) => {
        //                             console.log(err)
        //                         })
        //                 }
        //             })
        //             .catch((error) => {
        //                 const { message } = error
        //                 this.$bvModal
        //                     .msgBoxOk(message || 'Ha ocurrido un error!', {
        //                         title: 'Error!',
        //                         size: 'sm',
        //                         buttonSize: 'sm',
        //                         okVariant: 'error',
        //                         okTitle: 'Aceptar',
        //                         cancelTitle: 'Cancelar',
        //                         footerClass: 'p-2',
        //                         hideHeaderClose: false,
        //                         centered: true,
        //                         headerBgVariant: 'error',
        //                         headerClass: 'modal-header'
        //                     })
        //                     .then(() => {
        //                         // console.log(value);
        //                     })
        //                     .catch((err) => {
        //                         console.log(err)
        //                     })
        //             })
        //     }
        // },
        save() {
            const valid = !this.$v.vendedor.$invalid
            if (valid) {
                this.isLoading = true
                const p_opc = this.vendedor.id ? 'UPDATE' : 'INSERT'
                this.vendedor.empresa_id = this.getUltimaEmpresa.id
                API.POST({
                    url: 'administracion/vendedor/crud',
                    data: {
                        p_datajson: {
                            ...this.vendedor
                        },
                        p_opc,
                        p_auditoriajson: this.auditoriajson
                    }
                })
                    .then((response) => {
                        const {
                            data: {
                                status: { status, mensaje, mensaje_exception }
                            }
                        } = response
                        this.isLoading = false
                        if (status === 'ok') {
                            this.isSaved = true
                            // this.empresa = defaultEmpresa()
                            this.back()
                        } else {
                            this.$bvModal
                                .msgBoxOk(
                                    mensaje ||
                                        mensaje_exception ||
                                        'Ha ocurrido un error!',
                                    {
                                        title: 'Error!',
                                        size: 'sm',
                                        buttonSize: 'sm',
                                        okVariant: 'error',
                                        okTitle: 'Aceptar',
                                        cancelTitle: 'Cancelar',
                                        footerClass: 'p-2',
                                        hideHeaderClose: false,
                                        centered: true,
                                        headerBgVariant: 'error',
                                        headerClass: 'modal-header'
                                    }
                                )
                                .then(() => {
                                    // console.log(value);
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false
                        const { message } = error
                        this.$bvModal
                            .msgBoxOk(message || 'Ha ocurrido un error!', {
                                title: 'Error!',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'error',
                                okTitle: 'Aceptar',
                                cancelTitle: 'Cancelar',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true,
                                headerBgVariant: 'error',
                                headerClass: 'modal-header',
                                noStacking: true
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    })
            } else {
                this.$v.vendedor.$touch()
            }
        },
        back() {
            this.$router.back()
        },
        validateState(key) {
            const { $dirty, $error } = this.$v.vendedor[key]
            return $dirty ? !$error : null
        }
    },
    computed: {
        keymap() {
            if (
                navigator.platform.toLowerCase().includes('mac') ||
                navigator.platform.toLowerCase().includes('macintosh')
            ) {
                return {
                    'command+shift+s': this.read_only ? () => {} : this.save,
                    esc: this.back
                }
            } else if (
                navigator.platform.toLowerCase().includes('win') ||
                navigator.platform.toLowerCase().includes('windows')
            ) {
                return {
                    'ctrl+shift+s': this.read_only ? () => {} : this.save,
                    esc: this.back
                }
            } else {
                return {}
            }
        },
        auditoriajson() {
            const json = { ...this.getAuditoriaJson, modulo_id: 25 }
            return json
        },
        ...mapGetters('usuario', ['getUserData', 'getAuditoriaJson']),
        ...mapGetters('empresas', ['getUltimaEmpresa'])
    }
}
</script>

<style></style>
